jQuery(document).ready(function($) {
    $('#review_form').submit(function(event) {
        event.preventDefault();

        var textReview = $('textarea[name="review_message"]').val();
        var starsRating = $('.rating--add').attr('data-rating');
        var userName = $('input[name="user_name"]').val();
        var postId = $('#review_form').attr('data-post-id');

        // Перевірка довжини повідомлення
        if (textReview.length < 35) {
            $('#message_symbol').addClass('error-symbol');
        } else {
            $('#message_symbol').removeClass('error-symbol');
        }

        // Перевірка на порожнє ім'я
        if (userName.trim() === '') {
            $('input[name="user_name"]').addClass('error-review-name');
        } else {
            $('input[name="user_name"]').removeClass('error-review-name');
        }

        // Перевірка рейтингу
        if (starsRating == 0) {
            $('#rating_result_field').addClass('error-symbol');
        } else {
            $('#rating_result_field').removeClass('error-symbol');
        }

        // Якщо все ок, робимо AJAX запит
        if (textReview.length >= 35 && userName.trim() !== '') {
            $.ajax({
                type: 'POST',
                url: ajax_comments.ajax_url,
                data: {
                    action: 'comments_functional',
                    text_review: textReview,
                    stars: starsRating,
                    user_name: userName,
                    post_id: postId
                },
                success: function(response) {
                    $('#modal-success').addClass('open');
                    $('#review_form').hide();
                    $('textarea[name="review_message"]').val('');
                    $('input[name="user_name"]').val('');
                    $('.rating--add').attr('data-rating', '0');
                    $('#message_symbol').removeClass('error-symbol');

                    setTimeout(function() {
                        $('#modal-success').removeClass('open');
                    }, 5000);
                },
            });
        }
    });
});
